//=============================================================================
//                       <--- Developed By Icon Team --->
//=============================================================================

// npm packages
import React, {
  useState,
  useCallback,
  useEffect,
  Fragment,
  useContext,
} from "react";
import { CSVLink } from "react-csv";
import * as moment from "moment";
import { toast } from "react-toastify";

// custom pages
import { styles } from "./styles";
import report from "apis/Report/Report";
import { Burn } from "./config/config";
import { toastCss, successCss } from "assets/styleJS/global";
import NoData from "components/Table/NoData";
import Loader from "components/Loader/Loader";
import Context from "context/context";

// material-ui
import { withStyles } from "@material-ui/core/styles";
import {
  DatePicker,
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import Grid from "@material-ui/core/Grid";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";
import CircularProgress from "@material-ui/core/CircularProgress";

// material-ui icons
import HighlightOffIcon from "@material-ui/icons/HighlightOff";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import { useTranslation } from 'react-i18next';
import { enUS, fr } from "date-fns/locale";
import {dateFormat} from "helpers/dataFormat"
const GlobalCss = withStyles({
  "@global": {
    " .MuiDialog-scrollPaper": {},
    ".MuiDialog-paperWidthSm": {
      overflow: "hidden",
      maxWidth: "none",
    },
    " .MuiDialog-paper ": {},
  },
})(() => null);

export default function BurnFunc(props) {
  const { state, dispatch } = useContext(Context);
  const { page, setDisableDropdown } = props;
  const { burnAPI } = report();
  const classes = styles();
  const { t, i18n } = useTranslation();
  const [selectedDate, handleDateChange] = useState(new Date());

  const [states, setstates] = useState({
    columns: [],
    selectedColumns: [],
    selectedFields: [],
    selectedHeaders: [],
    dialog: false,
    data: [],
    response: false,
    startDate: null,
    endDate: null,
    dateApplied: false,
    filterColumn: "",
    filterValue: "",
    filterApplied: false,
    groupBy: "",
    groupByApplied: false,
    pLoading: false,
    eLoading: false,
  });

  const setStates = useCallback((newState) => {
    setstates((states) => ({ ...states, ...newState }));
  }, []);

  // setting checkboxes
  useEffect(() => {
    let label = Burn?.columns?.map((c) => c.label);
    if(state?.userInfo?.loyalty_organization_name != 'Henry Schein Canada'){
      let index = label.indexOf("Tier");
      let x = label.splice(index, 1);
      index = label.indexOf("Customer Sales Division Code");
      x = label.splice(index, 1);
      index = label.indexOf("Market Class Code");
      x = label.splice(index, 1);
      index = label.indexOf("Segment Code");
      x = label.splice(index, 1);
      index = label.indexOf("Customer Account Type Code");
      x = label.splice(index, 1);
      let index1 = label.indexOf("Billto Province Code");
      label.splice(index1, 1);  
      let index2= label.indexOf("Shipto Province Code");
      label.splice(index2, 1); 
    }
    setStates({ columns: label, selectedColumns: label });
  }, []);

  // Burn api func
  const handleGetBurn = async () => {
    try {
      setDisableDropdown(true);
      let selectedColumnKeys = [];

      let selectedObj = [];
      let selectedHeaders = [];

      states.selectedColumns.map(
        (s) => (selectedObj = [...selectedObj, { label: s }])
      );

      Burn.columns.map((c) => {
        selectedObj.map((s) => {
          if (c.label === s.label) {
            selectedHeaders = [...selectedHeaders, { ...c, label: t(c.label) }];
          }
        });
      });

      Burn.columns.map((c, i) => {
        if (states.selectedColumns?.includes(c.label)) {
          selectedColumnKeys = [...selectedColumnKeys, c.key];
          return;
        }
      });

      setStates({
        selectedFields: selectedColumnKeys,
        selectedHeaders: selectedHeaders,
      });

      let values = {
        fields: selectedColumnKeys,
      };
      if (states.dateApplied) {
        values = {
          ...values,
          startDate: moment(states.startDate).format("MM/DD/YYYY"),
          endDate: moment(states.endDate).format("MM/DD/YYYY"),
        };
      }
      if (states.filterApplied) {
        values = {
          ...values,
          filterBy: { [states.filterColumn]: [states.filterValue] },
        };
      }
      if (states.groupByApplied) {
        values = { ...values, groupBy: states.groupBy };
      }
      let res = await burnAPI(values);
      if (res && res.data) {
        dispatch({ type: "SET_REPORT_RES_COUNT", payload: 0 });
        setStates({
          data: res.data,
          response: true,
          pLoading: false,
          eLoading: false,
        });
        setDisableDropdown(false);
        if (res.data.length === 0) {
          toast.success(t("No Data Found"), { toastId: "no-report-date" });
          return;
        }
        return true;
      }
    } catch (err) {
      console.log(err);
    }
  };

  // handling customer accounts checkbox
  const checkboxOnChange = (c) => {
    if (!states.selectedColumns?.includes(c)) {
      let selected = [...states.selectedColumns, c];
      let data = [];

      let a = states.columns?.map((c) => {
        selected.map((s) => {
          if (c == s) {
            data = [...data, c];
          }
        });
      });

      setStates({
        selectedColumns: data,
      });
    } else {
      let arr = states.selectedColumns?.filter((e) => e !== c);
      setStates({
        selectedColumns: arr,
      });
    }
  };

  const pointsFormat = (value) => {
    if (value) {
      var nfObject = new Intl.NumberFormat("en-US");
      var points = nfObject.format(value);
      return points;
    }
    return "";
  };

  const pointsDecimalFormat = (value) => {
    if (value) {
      var points = value.toLocaleString("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
      return points;
    }
    return "";
  };

  const locale = i18n.language == 'fr' ? fr : enUS

  return (
    <div>
      <GlobalCss />
      <div className={classes.headText}>
        {t('Select date range')}{" "}
        {states.dateApplied && (
          <React.Fragment>
            <span className={classes.appliedSpan}>
              <CheckCircleIcon />
            </span>
            <span
              className={classes.removeSpan}
              onClick={() => {
                setStates({
                  dateApplied: false,
                  startDate: null,
                  endDate: null,
                });
              }}
            >
              {t('Remove')}
            </span>
          </React.Fragment>
        )}
      </div>
      <div className={classes.inputsDiv}>
        <Grid container spacing={0}>
          <Grid item xs={12} md={3}>
            <MuiPickersUtilsProvider utils={DateFnsUtils} locale={locale}>
              <KeyboardDatePicker
                disableToolbar
                variant="inline"
                format={i18n.language == "en" ? "MM/dd/yyyy" : "dd/MM/yyyy"}
                margin="normal"
                label={t("Start Date")}
                id="date-picker-inline"
                className={classes.dateInput}
                value={states.startDate}
                maxDate={new Date()}
                onChange={(date) => {
                  if (moment(date).isAfter(states.endDate)) {
                    toast.error("Start date should be greater than End date.", {
                      toastId: "start-date-end-date",
                    });
                    return;
                  }
                  setStates({ startDate: date, dateApplied: true });
                }}
                KeyboardButtonProps={{
                  "aria-label": "change date",
                }}
                autoOk
              />
            </MuiPickersUtilsProvider>
          </Grid>
          <Grid item xs={12} md={3}>
            <MuiPickersUtilsProvider utils={DateFnsUtils} locale={locale}>
              <KeyboardDatePicker
                disableToolbar
                variant="inline"
                format={i18n.language == "en" ? "MM/dd/yyyy" : "dd/MM/yyyy"}
                margin="normal"
                label={t("End Date")}
                id="date-picker-inline2"
                className={classes.dateInput}
                value={states.endDate}
                maxDate={new Date()}
                onChange={(date) => {
                  if (moment(states.startDate).isAfter(date)) {
                    toast.error("Start date should be greater than End date.", {
                      toastId: "start-date-end-date",
                    });
                    return;
                  }
                  setStates({ endDate: date, dateApplied: true });
                }}
                KeyboardButtonProps={{
                  "aria-label": "change date",
                }}
                autoOk
              />
            </MuiPickersUtilsProvider>
          </Grid>
        </Grid>
      </div>
      <div className={classes.headText}>
        {t('Filter by')}
        {states.filterApplied && (
          <React.Fragment>
            <span className={classes.appliedSpan}>
              {" "}
              <CheckCircleIcon />
            </span>
            <span
              className={classes.removeSpan}
              onClick={() => {
                setStates({
                  filterApplied: false,
                  filterColumn: "",
                  filterValue: "",
                });
              }}
            >
              {t('Remove')}
            </span>
          </React.Fragment>
        )}
      </div>
      <Grid container spacing={0} className={classes.inputsDiv}>
        <Grid item xs={12} md={3}>
          <TextField
            id={"filter-column"}
            label={t("Filter Column")}
            select
            type={"text"}
            className={classes.filterInput}
            value={states.filterColumn}
            onChange={(e) => {
              setStates({
                filterColumn: e.target.value,
                filterApplied: true,
              });
            }}
          >
            {Burn.filter.map((r, i) => (
              <MenuItem value={r.key} key={i}>
                {t(r.label)}
              </MenuItem>
            ))}
          </TextField>
        </Grid>
        <Grid item xs={12} md={3}>
          {states.filterColumn?.length > 0 && (
            <TextField
              id={"filter-value"}
              label={t("Filter Value")}
              required
              type={"text"}
              className={classes.filterInput}
              value={states.filterValue}
              onChange={(e) => {
                setStates({
                  filterValue: e.target.value,
                });
              }}
            ></TextField>
          )}
        </Grid>
      </Grid>
      <div className={classes.headText}>
        {t('Sort by')}
        {states.groupByApplied && (
          <React.Fragment>
            <span className={classes.appliedSpan}>
              <CheckCircleIcon />
            </span>
            <span
              className={classes.removeSpan}
              onClick={() => {
                setStates({
                  groupByApplied: false,
                  groupBy: "",
                });
              }}
            >
              {t('Remove')}
            </span>
          </React.Fragment>
        )}
      </div>
      <Grid container spacing={0} className={classes.inputsDiv}>
        <Grid xs={12} md={3}>
          <TextField
            id={"group"}
            label={t("Sort")}
            select
            type={"text"}
            className={classes.groupInput}
            value={states.groupBy}
            onChange={(e) => {
              setStates({
                groupBy: e.target.value,
                groupByApplied: true,
              });
            }}
          >
            {Burn.group.map((r, i) => (
              <MenuItem value={r.key} key={i}>
                {t(r.label)}
              </MenuItem>
            ))}
          </TextField>
        </Grid>
      </Grid>
      <div className={classes.headText}>{t('Select fields to be exported')}</div>
      <Grid container spacing={0} className={classes.inputsDiv}>
        {states.columns?.map((c, i) => (
          <Grid item xs={6}>
            <FormControlLabel
              key={i}
              control={
                <Checkbox
                  checked={states.selectedColumns?.includes(c)}
                  onChange={(e) => {
                    if (e.target.checked) {
                      checkboxOnChange(c);
                    }
                    if (
                      (states.groupBy === "loyalty_id" && c === "Loyalty ID") ||
                      (states.groupBy === "customer_billto_account_number" &&
                        c == "Bill to Account ID")
                    ) {
                      return false;
                    }
                    checkboxOnChange(c);
                  }}
                  name="checkedB"
                  color="primary"
                />
              }
              label={t(c)}
            />
          </Grid>
        ))}
      </Grid>
      <CSVLink
        id="csv"
        data={states.data}
        headers={states.selectedHeaders}
        filename={
          t(page) + " " + moment(new Date()).format("MM-DD-YYYY,h:mm A") + ".csv"
        }
        className={classes.CSVlink}
      />
      <div className={classes.exportAndPreview}>
        <Button
          className={classes.previewBtn}
          onClick={async () => {
            if (states?.selectedColumns.length == 0) {
              toast.error("Select atleast one Field.", {
                toastId: "empty-fields",
              });
              return;
            }
            if (states.filterApplied && !states.filterValue) {
              toast.error("Enter filter value.", {
                toastId: "filter-value",
              });
              return;
            }

            if (
              (states.startDate && !states.endDate) ||
              (!states.startDate && states.endDate)
            ) {
              toast.error(
                "Please select the both Start-date and End-date values",
                {
                  toastId: "empty-fields",
                }
              );
              return;
            }
            if (
              states.startDate?.toString() === "Invalid Date" &&
              states.endDate?.toString() === "Invalid Date"
            ) {
              toast.error("Invalid date.", {
                toastId: "invalid-date",
              });
              setStates({ startDate: new Date(), endDate: new Date() });
              return;
            } else if (states.startDate?.toString() === "Invalid Date") {
              toast.error("Invalid date.", {
                toastId: "invalid-s-date",
              });
              setStates({ startDate: new Date() });
              return;
            } else if (states.endDate?.toString() === "Invalid Date") {
              toast.error("Invalid date.", {
                toastId: "invalid-e-date",
              });
              setStates({ endDate: new Date() });
              return;
            }
            setStates({ response: false, data: [], pLoading: true });
            let res = await handleGetBurn();
            if (res) {
              setStates({ dialog: true });
            }
          }}
          disabled={states.pLoading || states.eLoading}
        >
          {states.pLoading ? (
            <React.Fragment>
              <CircularProgress
                style={{ height: 25, width: 25 }}
                variant="determinate"
                value={state.reportResCount}
              />{" "}
              &nbsp;
              <span style={{ color: "#305698", fontWeight: "bold" }}>
                {state.reportResCount == 0 ?
                  <div className="snippet">
                    <div className="stage">
                      <div className="dot-typing-p"></div>
                    </div>
                  </div> : `${state.reportResCount}%`}
              </span>
            </React.Fragment>
          ) : (
            t("Preview")
          )}
        </Button>
        <Button
          className={classes.exportBtn}
          onClick={async () => {
            if (states?.selectedColumns.length == 0) {
              toast.error("Select atleast one Field.", {
                toastId: "empty-fields",
              });
              return;
            }
            if (states.filterApplied && !states.filterValue) {
              toast.error("Enter filter value.", {
                toastId: "filter-value",
              });
              return;
            }

            if (
              (states.startDate && !states.endDate) ||
              (!states.startDate && states.endDate)
            ) {
              toast.error(
                "Please select the both Start-date and End-date values",
                {
                  toastId: "empty-fields",
                }
              );
              return;
            }
            if (
              states.startDate?.toString() === "Invalid Date" &&
              states.endDate?.toString() === "Invalid Date"
            ) {
              toast.error("Invalid date.", {
                toastId: "invalid-date",
              });
              setStates({ startDate: new Date(), endDate: new Date() });
              return;
            } else if (states.startDate?.toString() === "Invalid Date") {
              toast.error("Invalid date.", {
                toastId: "invalid-s-date",
              });
              setStates({ startDate: new Date() });
              return;
            } else if (states.endDate?.toString() === "Invalid Date") {
              toast.error("Invalid date.", {
                toastId: "invalid-e-date",
              });
              setStates({ endDate: new Date() });
              return;
            }
            setStates({ response: false, data: [], eLoading: true });
            let res = await handleGetBurn();
            if (res) {
              let data = [];
              document.getElementById("csv").click();
            }
          }}
          disabled={states.eLoading || states.pLoading}
        >
          {states.eLoading ? (
            <React.Fragment>
              <CircularProgress
                style={{ height: 25, width: 25, color: "#fff" }}
                variant="determinate"
                value={state.reportResCount}
              />
              &nbsp;
              <span style={{ color: "#fff", fontWeight: "bold" }}>
                {state.reportResCount == 0 ?
                  <div class="snippet">
                    <div class="stage">
                      <div class="dot-typing-e"></div>
                    </div>
                  </div> : `${state.reportResCount}%`}
              </span>
            </React.Fragment>
          ) : (
            t("Export CSV")
          )}
        </Button>
      </div>

      <Dialog
        onClose={() => {
          setStates({ dialog: false });
        }}
        aria-labelledby="simple-dialog-title"
        open={states.dialog}
      >
        <div className={classes.mainDiv}>
          <Grid container spacing={0}>
            <Grid item xs={12} className={classes.gridOne}>
              {page + " " + "Report"}
              <HighlightOffIcon
                className={classes.gridTwo}
                onClick={() => {
                  setStates({ dialog: false });
                }}
              />
            </Grid>
            <Grid item xs={12} className={classes.gridFive}>
              <span style={{ fontWeight: "bold" }}>{t('Generated Date')} : </span>
              <span>{dateFormat(moment(new Date()).format("MM-DD-YYYY"), i18n.language)}</span>
            </Grid>
          </Grid>
          {states.response ? (
            states.data && states.data.length > 0 ? (
              <TableContainer className={classes.tableContainer}>
                <Table
                  className={classes.table}
                  aria-labelledby="tableTitle"
                  size={"medium"}
                  aria-label="enhanced table"
                >
                  <TableHead className={classes.tableHead}>
                    <TableRow>
                      {states.selectedColumns?.map((h, i) => (
                        <TableCell key={i} className={classes.tableHeading}>
                          <div
                            className={
                              (states.groupBy === "loyalty_id" &&
                                h === "Loyalty ID") ||
                                (states.groupBy ===
                                  "customer_billto_account_number" &&
                                  h == "Bill to Account ID")
                                ? classes.groupByMarker
                                : classes.noDisplay
                            }
                          >{`(${t('Sort by')})`}</div>
                          <div>{t(h)}</div>
                        </TableCell>
                      ))}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {states.data?.slice(0, 10)?.map((p, i) => (
                      <TableRow role="checkbox" tabIndex={-1} key={i}>
                        {states.selectedFields.map((s) => (
                          <TableCell align="left" className={classes.rowCell}>
                            {s === "points_redeemed"
                              ? pointsFormat(p?.[s])
                              : s === "credit_issued"
                                ? pointsDecimalFormat(p?.[s])
                                : p?.[s]}
                          </TableCell>
                        ))}
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            ) : (
              <NoData />
            )
          ) : (
            <Loader Loading={!states?.response}></Loader>
          )}
        </div>
        {states.data && states.data.length > 0 && (
          <Grid container spacing={0}>
            <Grid xs={12} className={classes.gridFour}>
              <Button
                className={classes.previewBtn}
                onClick={() => {
                  setStates({ dialog: false });
                }}
              >
                {t('Cancel')}
              </Button>
              <Button
                className={classes.exportBtn}
                onClick={() => {
                  setStates({ dialog: false });
                  document.getElementById("csv").click();
                }}
              >
                {t('Export CSV')}
              </Button>
            </Grid>
          </Grid>
        )}
      </Dialog>
    </div>
  );
}
